
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AspectRatio } from "@/components/ui/aspect-ratio";

const SectionThree = () => {
  const { data: images } = useQuery({
    queryKey: ["images", "section-three"],
    queryFn: async () => {
      console.log("Fetching images for section-three");
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "section-three")
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });

  const getBackgroundImage = () => {
    if (images && images.length > 0) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[0].storage_path);
      return data.publicUrl;
    }
    return 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80';
  };

  return (
    <div id="ns3" className="relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50" />
      <div className="relative bg-gradient-to-r from-[#243949] to-[#517fa4] [&>*]:relative">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <h3 className="text-lg md:text-xl font-bold text-white mb-8 text-center uppercase">
            Damit Sie einen Eindruck von mir bekommen...
          </h3>
          
          {/* Image section */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-full max-w-xl">
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <div className="relative aspect-[16/9] w-full">
                  <img
                    src={getBackgroundImage()}
                    alt="Beratung und Coaching"
                    className="rounded-lg object-cover w-full h-full border-2 border-white/40"
                  />
                </div>
              </div>
            </div>
            <p className="text-lg md:text-xl text-white/90 mt-4 text-center">
              ...ein paar Reden aus verschiedenen Situationen von mir
            </p>
          </div>

          {/* Video section - 4 Videos */}
          <div className="mt-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {/* Video 1 */}
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <h3 className="text-sm font-bold mb-3 text-white text-center uppercase">
                  Poetry Slam 1
                </h3>
                <AspectRatio ratio={16/9}>
                  <iframe
                    className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                    src="https://www.youtube.com/embed/WqFExVvGKaE"
                    title="Poetry Slam 1"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </AspectRatio>
              </div>
              
              {/* Video 2 */}
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <h3 className="text-sm font-bold mb-3 text-white text-center uppercase">
                  Poetry Slam 2
                </h3>
                <AspectRatio ratio={16/9}>
                  <iframe
                    className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                    src="https://www.youtube.com/embed/0c86uyGfzJo"
                    title="Poetry Slam 2"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </AspectRatio>
              </div>
              
              {/* Video 3 */}
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <h3 className="text-sm font-bold mb-3 text-white text-center uppercase">
                  Jahreshauptversammlung FC Bayern
                </h3>
                <AspectRatio ratio={16/9}>
                  <iframe
                    className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                    src="https://www.youtube.com/embed/VAwcbz9YgGM"
                    title="Jahreshauptversammlung FC Bayern"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </AspectRatio>
              </div>
              
              {/* Video 4 */}
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <h3 className="text-sm font-bold mb-3 text-white text-center uppercase">
                  Der Sieg des Lebens über die Dunkelheit - Ostern
                </h3>
                <AspectRatio ratio={16/9}>
                  <iframe
                    className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                    src="https://www.youtube.com/embed/cPw08a0pKB8"
                    title="Der Sieg des Lebens über die Dunkelheit - Ostern"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </AspectRatio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionThree;
